import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import { saveAs } from "file-saver";
import axios from "axios";
// import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
  name: "NewExPage",
  data() {
    let ss = new MainService();
    return {
      msg: "NewExPage",
      ss: ss,
      ajax: {
        url: ss.indexNewEx(),
        headers: ss.getToken(),
      },
      newexs: [],
      newex: {},
      isLoading: false,
      errorBag: {},
      carreras: [],
      selectedCarrera1: null, 
      selectedCarrera2: null,
      selectedSemestre1: null,
      selectedSemestre2: null,
      selectedPeriodo1: null,
      selectedPeriodo2: null,
    };
  },
  methods: {
    CargarNewEx() {
      this.ss
        .listNewEx()
        .then((result) => {
          this.carreras = result.data.data; // almacena los datos de las carreras
        })
        .catch((error) => {
        });
    },
    withNewEx(selectedCarrera1, selectedSemestre1, selectedPeriodo1) {
      this.ss
        .conNewEx(selectedCarrera1, selectedSemestre1,selectedPeriodo1)
        .then((response) => {
          let blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "AlumnosCertificados.xlsx");
        })
        .catch((error) => {
        });
    },
    withinNewEx(selectedCarrera2, selectedSemestre2, selectedPeriodo2) {
      this.ss
        .sinNewEx(selectedCarrera2, selectedSemestre2, selectedPeriodo2)
        .then((response) => {
          let blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "AlumnosSinCertificados.xlsx");
        })
        .catch((error) => {
        });
    },
    withPdfNewEx(selectedCarrera1, selectedSemestre1, selectedPeriodo1) {
      this.ss
        .conPdfNew(selectedCarrera1, selectedSemestre1,selectedPeriodo1)
        .then((response) => {
          window.open(response.data.pdf_url);
        })
        .catch((error) => {
          this.errorBag = error.response.data.errors;
          this.$bvToast.toast("Seleccione una Carrera", {
            title: "Error",
            variant: "danger",
            autoHideDelay: 5000,
          });
        });
    },
    withinPdfNewEx(selectedCarrera2, selectedSemestre2, selectedPeriodo2) {
      this.ss
        .sinPdfNew(selectedCarrera2, selectedSemestre2, selectedPeriodo2)
        .then((response) => {
          window.open(response.data.pdf_url);
        })
        .catch((error) => {
        });
    },
    extraerdatos() {
      this.ss
        .extractCreateInst()
        .then((response) => {
        })
        .catch((error) => {
        });
    },
  },
  components: {
    dataTable,
    // Loader
  },
  computed: {
    persona() {
      return JSON.parse(localStorage.getItem("persona"));
    },
  },
  mounted() {
    this.CargarNewEx();
    var persona = JSON.parse(localStorage.getItem("persona"));
    if (!persona) {
      this.$router.push("/Login");
    }
  },
};
